<template>
  <v-app
    :style="loggingOut ? { opacity: 0.5 } : {}"
  >
    <div
      v-if="sessionLoading"
      class="loading-spinner-wrapper d-flex align-center justify-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <login-view
      v-else-if="requireAuth"
      @close="$store.commit('setRequireAuth', false)"
    />
    <template
      v-else
    >
      <left-navigation
      />
      <v-main>
        <router-view/>
      </v-main>
      <cm-footer
      />
    </template>

    <returns-dialog
      v-if="returnsDialog"
    />
    <contact-support-dialog
      v-if="supportDialog"
    />

    <v-snackbar
      color="error"
      :value="!!appError"
      vertical
      timeout="5000"
      @input="setAppError"
      multi-line
    >
      {{ appError || '' }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="setAppError(false)"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<style lang="scss">
body {
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
}
.loading-spinner-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
}
</style>

<script>
import LeftNavigation from '@/components/LeftNavigation'
import ReturnsDialog from '@/components/ReturnsDialog'
import ContactSupportDialog from '@/components/ContactSupportDialog'
import CmFooter from '@/components/Footer'
import { mapState, mapMutations } from 'vuex'
import LoginView from '@/views/Login'

export default {
  components: {
    LeftNavigation,
    ReturnsDialog,
    ContactSupportDialog,
    CmFooter,
    LoginView
  },
  computed: {
    ...mapState(['sessionLoading', 'loggingOut', 'requireAuth', 'appError', 'returnsDialog', 'supportDialog'])
  },
  methods: {
    ...mapMutations(['setAppError'])
  }
}
</script>
